/** Resolve stored upload keys (profiles, inventory) to a browser-loadable URL. */
export function fileAssetUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;

  let assetPath = String(path).replace(/\\/g, "/");
  if (!assetPath.startsWith("/")) assetPath = `/${assetPath}`;
  // Production nginx serves the SPA for /uploads/*; Express serves files at /api/files/*.
  if (assetPath.startsWith("/uploads/")) {
    assetPath = `/api/files/${assetPath.slice("/uploads/".length)}`;
  } else if (
    assetPath.startsWith("/profiles/") ||
    assetPath.startsWith("/inventory/")
  ) {
    assetPath = `/api/files${assetPath}`;
  }

  const api = process.env.REACT_APP_API_BASE_URL || "/api";
  const base = process.env.REACT_APP_BACKEND_URL
    ? process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")
    : api.startsWith("http")
      ? api.replace(/\/api\/?$/, "")
      : "";
  return `${base}${assetPath}`;
}

/** Download a DOM node as PNG using print (fallback) or canvas. */
export async function downloadNodeAsPng(node, filename = "id-card.png") {
  if (!node) return;

  try {
    const html2canvas = (await import("html2canvas")).default;
    const canvas = await html2canvas(node, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: "#ffffff",
    });
    const link = document.createElement("a");
    link.download = filename;
    link.href = canvas.toDataURL("image/png");
    link.click();
  } catch {
    window.print();
  }
}
